// Dashboard's foot area — Phase 2b reserved the `data-slot="foot"` seam;
// Phase 3a fills it with the two accordions.

import type { JSX, ReactNode } from "react";

interface DashFootProps {
  readonly children: ReactNode;
}

export const DashFoot = ({ children }: DashFootProps): JSX.Element => (
  <div className="dash-foot" data-slot="foot">
    {children}
  </div>
);
